import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { trackInitiateCheckout } from '../lib/metaPixel';
type PurchaseButtonProps = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  productName: string;
  value: number;
  trackCheckout?: boolean;
};
type NavigatorWithConnection = Navigator & {
  connection?: {
    saveData?: boolean;
  };
};
const TEMPORARY_STORE_URL = 'https://www.avanzapro.store';
export function PurchaseButton({
  children,
  className = '',
  href = TEMPORARY_STORE_URL,
  productName,
  value,
  trackCheckout = true
}: PurchaseButtonProps) {
  const prefersReducedMotion = useReducedMotion();
  const [canUseDecorativeMotion, setCanUseDecorativeMotion] = useState(false);
  useEffect(() => {
    const desktopPointerQuery = window.matchMedia('(min-width: 640px) and (hover: hover) and (pointer: fine)');
    const navigatorWithConnection = navigator as NavigatorWithConnection;
    const updateMotionPreference = () => {
      setCanUseDecorativeMotion(desktopPointerQuery.matches && !Boolean(navigatorWithConnection.connection?.saveData));
    };
    updateMotionPreference();
    desktopPointerQuery.addEventListener('change', updateMotionPreference);
    return () => {
      desktopPointerQuery.removeEventListener('change', updateMotionPreference);
    };
  }, []);
  const shouldAnimate = !prefersReducedMotion && canUseDecorativeMotion;
  return <motion.a href={href} onClick={() => {
    if (trackCheckout) {
      trackInitiateCheckout({
        contentName: productName,
        value
      });
    }
  }} whileInView={shouldAnimate ? {
    scale: [1, 1.014, 1]
  } : undefined} viewport={{
    amount: 0.7
  }} transition={shouldAnimate ? {
    duration: 3.2,
    repeat: Infinity,
    ease: 'easeInOut'
  } : undefined} whileHover={shouldAnimate ? {
    scale: 1.025
  } : undefined} whileTap={{
    scale: 0.98
  }} className={`inline-flex min-h-14 max-w-full items-center justify-center gap-2 rounded-full bg-blue-600 px-6 py-3 text-center text-sm font-black leading-5 text-white shadow-lg shadow-blue-950/30 focus:outline-none focus:ring-4 focus:ring-sky-300/40 sm:min-h-[3.75rem] ${className}`} data-id="element-13">
      <span data-id="element-14">{children}</span>
      <ArrowRightIcon size={18} className="shrink-0" aria-hidden="true" data-id="element-15" />
    </motion.a>;
}